<template>
    <v-dialog v-model="open">
    <template v-slot:activator="{ props: activatorProps }">
      <v-btn v-bind="activatorProps" @click="recordOpen">Contact</v-btn>
    </template>

    <template v-slot:default="{ isActive }">
      <v-card>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-card-title>Contact Info</v-card-title>
            </v-col>
            <v-col cols="12">
              <v-card-item class="text-subtitle-2">Note: All transactions are handled between you and the seller.  Dan's Tech Services and the software they provide (Cemetery Community) is not responsible for any part of the transaction.  Please be aware of scammers and flag posts that are suspect.</v-card-item>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-card-item>Seller Name: {{ item.sellername }}</v-card-item>
            </v-col>
          </v-row>
          <v-row v-if="item && item.phone">
            <v-col>
              <v-btn :text="'Phone: ' + item.phone" link :href="'tel:'+item.phone" @click="phoneClicked"/>
            </v-col>
          </v-row>
          <v-row v-if="item && item.email">
            <v-col>
              <v-btn :text="'Email: ' + item.email" link :href="'mailto:'+item.email" @click="emailClicked"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col align="right">
              <v-btn color="red" text="Close" @click="isActive.value = false;"/>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>

export default {
  name: 'ContactDialog',

  props:{
    item : Object
  },

  data: () => ({
    open : false
  }),

  methods:{
    recordOpen(){
      fetch("https://app.cemeterycommunity.com:11000/api/addmarketplaceitemlog", { method: "POST", headers : { data : JSON.stringify( { type : 'Contact Viewed', itemid : this.item.id } ) } });
    },
    emailClicked(){
      fetch("https://app.cemeterycommunity.com:11000/api/addmarketplaceitemlog", { method: "POST", headers : { data : JSON.stringify( { type : 'Email Clicked', itemid : this.item.id } ) } });
    },
    phoneClicked(){
      fetch("https://app.cemeterycommunity.com:11000/api/addmarketplaceitemlog", { method: "POST", headers : { data : JSON.stringify( { type : 'Phone Clicked', itemid : this.item.id } ) } });
    },
  }
}
</script>